import { isEqual as _isEqual } from "lodash-es";

export const on_before_leave_alert_if_unsaved = (
  saved_form_str,
  unsaved_form_str
) => ({
  methods: {
    oblaiu_is_form_dirty() {
      if (!this[saved_form_str] || !this[unsaved_form_str]) {
        return false;
      }
      let is_form_and_saved_form_are_equal = _isEqual(
        this[saved_form_str],
        this[unsaved_form_str]
      );
      return !is_form_and_saved_form_are_equal;
    },
    oblaiu_on_before_unload(e) {
      if (this.oblaiu_is_form_dirty() && !this.oblaiu_confirm_leave()) {
        // Cancel the event
        e.preventDefault();
        // Chrome requires returnValue to be set
        e.returnValue = "";
      }
    },
    oblaiu_confirm_leave(form_closing = false) {
      let msg =
        "Hey wait! You have unsaved changes. \nClick Ok to discard your changes and leave, or \nclick Cancel to stay in this page.";
      if (form_closing) {
        msg =
          "Hey wait! You have unsaved changes. \nClick Ok to discard your changes and continue, or \nclick Cancel to stay in this section.";
      }
      return window.confirm(msg);
    }
  },
  created() {
    window.addEventListener("beforeunload", this.oblaiu_on_before_unload);
  },
  beforeDestroy() {
    window.removeEventListener("beforeunload", this.oblaiu_on_before_unload);
  },
  beforeRouteLeave(to, from, next) {
    // If the form is not dirty or the user confirmed they want to lose unsaved changes,
    // continue to next view
    if (
      this.skip_leaving_warining ||
      !this.oblaiu_is_form_dirty() ||
      this.oblaiu_confirm_leave()
    ) {
      next();
    } else {
      // Cancel navigation
      next(false);
    }
  }
});
